import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";
import { initAccordions } from "../../../src/js/modules/accordion";

document.querySelectorAll(".solutions-services-section").forEach((el) => {
	initOnScrollAnimation(el);

	initAccordions(el);
});
